@if(step == 1){
    <div
    class="mt-[100px] text-justify-disabled aspect43:mt-[234px] flex flex-wrap place-content-center gap-[4%] aspect43:gap-5 gap-y-2.5">
    <!-- <div (click)="step = 2;completeData.role = 6"
        class="w-[48%] h-[200px] aspect43:w-[calc(33.33%-13.33px)] aspect43:h-[383px] rounded-[30px] p-5 aspect43:p-[25px] bg-primary hover:bg-quintary cursor-pointer">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25.0007 4.68518C13.8005 4.68518 4.68823 13.7975 4.68823 24.9977C4.68823 36.1979 13.8005 45.3102 25.0007 45.3102C36.2009 45.3102 45.3132 36.1979 45.3132 24.9977C45.3132 13.7975 36.2009 4.68518 25.0007 4.68518ZM25.196 14.0602C26.5867 14.0602 27.9461 14.4726 29.1024 15.2452C30.2587 16.0178 31.1599 17.1159 31.6921 18.4007C32.2243 19.6855 32.3635 21.0992 32.0922 22.4632C31.8209 23.8271 31.1512 25.0799 30.1679 26.0633C29.1846 27.0466 27.9317 27.7163 26.5678 27.9876C25.2038 28.2589 23.7901 28.1196 22.5053 27.5875C21.2205 27.0553 20.1224 26.1541 19.3498 24.9978C18.5772 23.8415 18.1648 22.4821 18.1648 21.0914C18.1648 19.2266 18.9056 17.4382 20.2242 16.1196C21.5428 14.801 23.3312 14.0602 25.196 14.0602ZM25.0007 42.1852C22.6301 42.1862 20.285 41.6955 18.1136 40.7441C15.9423 39.7927 13.9918 38.4013 12.3855 36.6578C13.2488 32.1871 21.0027 31.2477 25.0007 31.2477C28.9988 31.2477 36.7527 32.1871 37.616 36.6569C36.0099 38.4007 34.0595 39.7923 31.8881 40.7439C29.7167 41.6954 27.3715 42.1862 25.0007 42.1852Z"
                fill="#F1F5FF" />
        </svg>

        <div class="aspect43:h-[283px] flex pt-10">
            <div>
                <div
                    class="text-font24px font-semibold text-Swhite font-kansas aspect43:h-[115px] flex items-end aspect43:h-auto aspect43:mt-0">
                    Partner</div>
                <div class="mt-3 text-Swhite font-normal text-font18px hidden aspect43:flex">Individua relazioni
                    strategiche per i tuoi
                    progetti. La piattaforma ti aiuta a creare
                    consorzi e attivare collaborazioni mirate per rafforzare le candidature e aumentare
                    l’impatto delle iniziative
                </div>
                
            </div>

        </div>
    </div> -->
    <div (click)="step = 2;completeData.role = 2"
        class="w-[48%] h-[200px] aspect43:w-[calc(33.33%-13.33px)] aspect43:h-[383px] rounded-[30px] p-5 aspect43:p-[25px] bg-primary hover:bg-quintary cursor-pointer">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25.0007 4.68518C13.8005 4.68518 4.68823 13.7975 4.68823 24.9977C4.68823 36.1979 13.8005 45.3102 25.0007 45.3102C36.2009 45.3102 45.3132 36.1979 45.3132 24.9977C45.3132 13.7975 36.2009 4.68518 25.0007 4.68518ZM25.196 14.0602C26.5867 14.0602 27.9461 14.4726 29.1024 15.2452C30.2587 16.0178 31.1599 17.1159 31.6921 18.4007C32.2243 19.6855 32.3635 21.0992 32.0922 22.4632C31.8209 23.8271 31.1512 25.0799 30.1679 26.0633C29.1846 27.0466 27.9317 27.7163 26.5678 27.9876C25.2038 28.2589 23.7901 28.1196 22.5053 27.5875C21.2205 27.0553 20.1224 26.1541 19.3498 24.9978C18.5772 23.8415 18.1648 22.4821 18.1648 21.0914C18.1648 19.2266 18.9056 17.4382 20.2242 16.1196C21.5428 14.801 23.3312 14.0602 25.196 14.0602ZM25.0007 42.1852C22.6301 42.1862 20.285 41.6955 18.1136 40.7441C15.9423 39.7927 13.9918 38.4013 12.3855 36.6578C13.2488 32.1871 21.0027 31.2477 25.0007 31.2477C28.9988 31.2477 36.7527 32.1871 37.616 36.6569C36.0099 38.4007 34.0595 39.7923 31.8881 40.7439C29.7167 41.6954 27.3715 42.1862 25.0007 42.1852Z"
                fill="#F1F5FF" />
        </svg>

        <div class="aspect43:h-[283px] flex pt-10">
            <div>
                <div
                    class="text-font24px font-semibold text-Swhite font-kansas aspect43:h-[115px] flex items-end aspect43:h-auto aspect43:mt-0">
                    Imprese e startup</div>
                <div class="mt-3 text-Swhite font-normal text-font18px hidden aspect43:flex">Accedi ai bandi giusti, con
                    il supporto
                    giusto. Individua le opportunità più adatte al tuo progetto di innovazione, gestisci candidature e
                    scadenze in modo
                    centralizzato. L’AI lavora per te:
                    tu concentrati sul far crescere la tua idea
                </div>
                
            </div>
        </div>
    </div>
    <div (click)="step = 2;completeData.role = 4"
        class="w-[48%] h-[200px] aspect43:w-[calc(33.33%-13.33px)] aspect43:h-[383px] rounded-[30px] p-5 aspect43:p-[25px] bg-primary hover:bg-quintary cursor-pointer">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25.0007 4.68518C13.8005 4.68518 4.68823 13.7975 4.68823 24.9977C4.68823 36.1979 13.8005 45.3102 25.0007 45.3102C36.2009 45.3102 45.3132 36.1979 45.3132 24.9977C45.3132 13.7975 36.2009 4.68518 25.0007 4.68518ZM25.196 14.0602C26.5867 14.0602 27.9461 14.4726 29.1024 15.2452C30.2587 16.0178 31.1599 17.1159 31.6921 18.4007C32.2243 19.6855 32.3635 21.0992 32.0922 22.4632C31.8209 23.8271 31.1512 25.0799 30.1679 26.0633C29.1846 27.0466 27.9317 27.7163 26.5678 27.9876C25.2038 28.2589 23.7901 28.1196 22.5053 27.5875C21.2205 27.0553 20.1224 26.1541 19.3498 24.9978C18.5772 23.8415 18.1648 22.4821 18.1648 21.0914C18.1648 19.2266 18.9056 17.4382 20.2242 16.1196C21.5428 14.801 23.3312 14.0602 25.196 14.0602ZM25.0007 42.1852C22.6301 42.1862 20.285 41.6955 18.1136 40.7441C15.9423 39.7927 13.9918 38.4013 12.3855 36.6578C13.2488 32.1871 21.0027 31.2477 25.0007 31.2477C28.9988 31.2477 36.7527 32.1871 37.616 36.6569C36.0099 38.4007 34.0595 39.7923 31.8881 40.7439C29.7167 41.6954 27.3715 42.1862 25.0007 42.1852Z"
                fill="#F1F5FF" />
        </svg>

        <div class="aspect43:h-[283px] flex pt-10">
            <div>
                <div
                    class="text-font24px font-semibold text-Swhite font-kansas aspect43:h-[115px] flex items-end aspect43:h-auto aspect43:mt-0">
                    Enti Pubblici</div>
                <div class="mt-3 text-Swhite font-normal text-font18px hidden aspect43:flex">Semplifica l’accesso ai
                    fondi e valorizza
                    il tuo impatto. Innovation Smart Plaza aiuta a individuare risorse, monitorare i progetti e generare
                    report efficaci. La governance dell’innovazione sul territorio non è mai stata così facile
                </div>
                
            </div>
        </div>
    </div> </div>}

@if(step == 2){


<div class="fixed top-[100px] left-10 md:top-[190px] md:left-[60px] cursor-pointer size-fit z-50" (click)="step = 1">
    <svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M41.5 20.5723L5.03223 20.5723L18.3965 34.0654L18.7158 34.3877L18.4268 34.7373L17.1113 36.3193L16.7588 36.7441L16.3711 36.3516L0.64453 20.4238L0.499999 20.2773L0.499999 17.7227L0.644531 17.5762L16.3711 1.64844L16.7266 1.28906L17.082 1.64844L18.498 3.07715L18.8457 3.42871L18.499 3.78027L5.02832 17.4277L41.5 17.4277L41.5 20.5723Z"
            fill="#1F299C" stroke="#1F299C" />
    </svg>

</div>


<div class=" !w-screen h-[982px] custom-scroll flex place-content-center items-center absolute top-0 left-0 z-[2]"
    *transloco="let t;prefix:'auth'">
    <div class="h-fit max-w-[405px] aspect43:max-w-[825px]">
        <div title class="text-font36px md:text-font63px text-center text-quaternary mt-[80px] mb-[54px]">
            Completa le informazioni
        </div>

        <div id="scroll-inputs"
            class="md:min-w-[400px] place-content-start pb-10 aspect43:flex overflow-x-hidden aspect43:flex-wrap aspect43:gap-5 overflow-y-scroll custom-scroll mx-auto">
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="completeData.ragioneSociale"
                [value]="completeData.ragioneSociale" customLabel="label-input" [label]="'Ragione sociale*'"
                [placeholder]="'Inserisci ragione sociale'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="completeData.codiceFiscale"
                [value]="completeData.codiceFiscale" customLabel="label-input" [label]="'Codice fiscale*'"
                [placeholder]="'Inserisci codice fiscale'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="completeData.partitaIva"
                [value]="completeData.partitaIva" customLabel="label-input" [label]="'Partita IVA*'"
                [placeholder]="'Inserisci partita IVA'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="completeData.numeroDipendenti"
                [value]="completeData.numeroDipendenti" customLabel="label-input"
                [label]="'Numero Dipendenti(Opzionale)'" [placeholder]="'Inserisci numero dipendenti'"
                customContainerlass="mb-8" type="text">
            </std-input>
            <div>
            <!-- <div class="label-input !text-font24px">Fatturato ultimi 3 anni(Opzionale)</div>
            <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[0].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[0].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[0].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[0].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div> -->
            <!-- <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[1].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[1].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[1].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[1].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div> -->
            <!-- <div class="flex gap-5">
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[2].anno"
                    [value]="completeData.fatturatiUltimiTreAnni[2].anno" customLabel="label-input" [label]="'Anno'"
                    [placeholder]="'Inserisci anno'" customContainerlass="mb-8" type="number">
                </std-input>
                <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]"
                    [(ngModel)]="completeData.fatturatiUltimiTreAnni[2].valore"
                    [value]="completeData.fatturatiUltimiTreAnni[2].valore" customLabel="label-input"
                    [label]="'Fatturato'" [placeholder]="'Inserisci fatturato'" customContainerlass="mb-8"
                    type="number">
                </std-input>
            </div> -->
            </div>
            <!-- <div class="label-input !text-font30px flex gap-5 w-full">Sedi<div (click)="completeData.sedi.push({})"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    +</div>
            </div> -->
            <!-- @for (sede of completeData.sedi; track $index) {
                <div>
            <div class="label-input !text-font24px flex">Sede {{$index + 1}}<div (click)="removeSede($index)"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    -</div>
            </div>
            <std-select [filterable]="false" [currentValue]="sede.tipo ? {element:sede.tipo} : null"
                customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                customClassContaier="custom-select" class="w-[150px]" (onChangeValue)="
             sedeType($event,$index)
              " labelPosition="top" [label]="'Tipo'" [placeholder]="'Scegli tipo'" [data]="
              [{element:'LEGALE'},{element:'OPERATIVA'}]" bindLabel="element" bindValue="element"></std-select>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.indirizzo"
                [value]="sede.indirizzo" customLabel="label-input" [label]="'Indirizzo'"
                [placeholder]="'Inserisci indirizzo'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.cap" [value]="sede.cap"
                customLabel="label-input" [label]="'CAP'" [placeholder]="'Inserisci CAP'" customContainerlass="mb-8"
                type="number">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.citta" [value]="sede.citta"
                customLabel="label-input" [label]="'Citta'" [placeholder]="'Inserisci citta'" customContainerlass="mb-8"
                type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.provincia"
                [value]="sede.provincia" customLabel="label-input" [label]="'Provincia'"
                [placeholder]="'Inserisci provincia'" customContainerlass="mb-8" type="text">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="sede.stato" [value]="sede.stato"
                customLabel="label-input" [label]="'Stato'" [placeholder]="'Inserisci stato'" customContainerlass="mb-8"
                type="text">
            </std-input>
            </div>
            } -->
            <!-- <div class="label-input !text-font30px flex gap-5 w-full">Codici ateco<div (click)="completeData.ateco.push({})"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    +</div>
            </div> -->
            <!-- @for (ateco of completeData.ateco; track $index) {
            <div><div class="label-input !text-font24px flex">Ateco {{$index + 1}}<div (click)="removeAteco($index)"
                    class="ml-auto size-[45px] bg-quaternary select-none rounded-full flex items-center place-content-center text-Swhite text-font30px cursor-pointer">
                    -</div>
            </div>
            <std-select [filterable]="false" [currentValue]="ateco.tipo ? {element:ateco.tipo} : null"
                customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                customClassContaier="custom-select" class="w-[150px]" (onChangeValue)="
             atecoType($event,$index)
              " labelPosition="top" [label]="'Tipo'" [placeholder]="'Scegli tipo'" [data]="
              [{element:'PREVALENTE'},{element:'SECONDARIO'}]" bindLabel="element" bindValue="element"></std-select>
            <std-input labelPosition="top" customInputClass="custom-input md:!min-w-[400px]" [(ngModel)]="ateco.codice"
                [value]="ateco.codice" customLabel="label-input" [label]="'Codice'" [placeholder]="'Inserisci codice'"
                customContainerlass="mb-8" type="text">
            </std-input></div>
            } -->
        </div>
        <div class="ml-auto w-full mt-[40px]">
            <std-button (click)="confirmData()" id="button-login" size="sm"
                buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Conferma</std-button>

        </div>


    </div>
</div>
}